import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ApiServices from "../../services/apiServices";
import { useLoad } from "../../context/Load";
import "./index.css";
import { slide as MenuBurger } from "react-burger-menu";
import storage from "../../services/storage";
import Mask from "../../services/mask";
import logo from "../../assets/images/png/logo.png";
import iconMenu from "../../assets/images/png/iconMenu.png";
import Avatar from "../Avatar";
import papel from "../../assets/images/svg/papelNotificacao.svg";
import sino from "../../assets/images/svg/sinoNotificacao.svg";
import exclamacao from "../../assets/images/svg/exclamacao.svg";
import { toast } from "react-toastify";
import bola from "../../assets/images/png/bola.png";
import qrCode from "../../assets/images/svg/qrCode.svg";

export default function Menu() {
  const { setLoad } = useLoad();
  const [eu, setEu] = useState([]);
  const [pontosSaldo, setPontosSaldo] = useState(0);
  const [pontosCreditados, setPontosCreditados] = useState(0);
  const [pontos, setPontos] = useState([]);
  const [notificacoesListaFaleConosco, setNotificacoesListaFaleConosco] =
    useState([]);
  const [notificacoesListaNoticias, setNotificacoesListaNoticias] = useState(
    []
  );
  const [isBolaActive, setIsBolaActive] = useState(true);
  const [abrirNotificacaoFaleConosco, setAbrirNotificacaoFaleConosco] =
    useState(false);
  const [abrirNotificacaoNoticias, setAbrirNotificacaoNoticias] =
    useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  // Detectar se é mobile ou desktop
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);

    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  // Componente de partículas de fogo
  const FireParticles = ({ isActive }) => {
    const [particles, setParticles] = useState([]);
    const [smokeParticles, setSmokeParticles] = useState([]);

    useEffect(() => {
      if (!isActive) {
        setParticles([]);
        setSmokeParticles([]);
        return;
      }

      const createFireParticle = () => {
        return {
          id: Math.random(),
          x: 10 + (Math.random() - 0.5) * 6, // centro da bola (20px/2 = 10px) com variação
          y: 10 + (Math.random() - 0.5) * 6,
          vx: (Math.random() - 0.5) * 2,
          vy: -Math.random() * 3 - 1,
          life: 1,
          decay: Math.random() * 0.015 + 0.008,
          size: Math.random() * 3 + 1,
          color: `hsl(${Math.random() * 20 + 15}, 100%, ${
            Math.random() * 20 + 60
          }%)`,
          type: "fire",
        };
      };

      const createSmokeParticle = () => {
        return {
          id: Math.random(),
          x: 10 + (Math.random() - 0.5) * 4,
          y: 10 + (Math.random() - 0.5) * 4,
          vx: (Math.random() - 0.5) * 1,
          vy: -Math.random() * 1.5 - 0.5,
          life: 1,
          decay: Math.random() * 0.01 + 0.005,
          size: Math.random() * 4 + 2,
          color: `rgba(100, 100, 100, ${Math.random() * 0.3 + 0.2})`,
          type: "smoke",
        };
      };

      const interval = setInterval(() => {
        setParticles((prev) => {
          const newParticles = prev
            .map((p) => ({
              ...p,
              x: p.x + p.vx,
              y: p.y + p.vy,
              life: p.life - p.decay,
              vy: p.vy + 0.15, // gravidade
              vx: p.vx * 0.98, // resistência do ar
            }))
            .filter((p) => p.life > 0 && p.y < 50); // Limita a 50px de altura

          if (newParticles.length < 6) {
            newParticles.push(createFireParticle());
          }

          return newParticles;
        });

        setSmokeParticles((prev) => {
          const newSmoke = prev
            .map((p) => ({
              ...p,
              x: p.x + p.vx,
              y: p.y + p.vy,
              life: p.life - p.decay,
              vy: p.vy + 0.1,
              vx: p.vx * 0.95,
              size: p.size + 0.1, // fumaça cresce
            }))
            .filter((p) => p.life > 0 && p.y < 50); // Limita a 50px de altura

          if (newSmoke.length < 4) {
            newSmoke.push(createSmokeParticle());
          }

          return newSmoke;
        });
      }, 50);

      return () => clearInterval(interval);
    }, [isActive]);

    if (!isActive) return null;

    return (
      <div
        className="fire-particles-container"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "20px",
          height: "50px",
          pointerEvents: "none",
          zIndex: 1,
        }}
      >
        {/* Partículas de fumaça */}
        {smokeParticles.map((particle) => (
          <div
            key={`smoke-${particle.id}`}
            className="smoke-particle"
            style={{
              left: particle.x + "px",
              top: particle.y + "px",
              width: particle.size + "px",
              height: particle.size + "px",
              backgroundColor: particle.color,
              opacity: particle.life * 0.6,
              transform: `scale(${particle.life * 1.5})`,
            }}
          />
        ))}

        {/* Partículas de fogo */}
        {particles.map((particle) => (
          <div
            key={`fire-${particle.id}`}
            className="fire-particle"
            style={{
              left: particle.x + "px",
              top: particle.y + "px",
              width: particle.size + "px",
              height: particle.size + "px",
              backgroundColor: particle.color,
              opacity: particle.life,
              transform: `scale(${particle.life})`,
              boxShadow: `0 0 ${particle.size * 2}px ${particle.color}`,
            }}
          />
        ))}
      </div>
    );
  };

  // Componente do menu lateral para desktop
  const DesktopSidebar = () => (
    <div className="desktop-sidebar">
      <div className="desktop-sidebar-content">
        <div className="d-flex justify-content-center">
          <img width={200} src={logo} alt="" />
        </div>
        <br />
        {/* <div className="cardPerfilMenu">
          <div className="divAvatarMenu pointer">
            <Avatar nome={eu.nome} font={25} rota={"/meu-cadastro"} />
          </div>

          <div className="divInfoCardMenu">
            <div className="nomeCardPerfilMenu">{eu.nome}</div>
            <div className="filialCardPerfil">
              Filial {eu?.dealer?.nomeFantasia}
            </div>

            <hr />

            <div className="d-flex">
              <div className="">
                <div className="saldoAtualMenu">Saldo atual</div>

                <div className="pontosPerfilMenu">
                  {pontosSaldo?.toLocaleString("pt-br", {
                    minimumFractionDigits: 2,
                  })}
                </div>
              </div>
            </div>
          </div>
        </div> */}
       
        <Link to="/home">
          <div className="botaoMenu">
            <span>Pagina inicial</span>
          </div>
        </Link>
        <Link to="/meu-cadastro">
          <div className="botaoMenu">
            <span>Meu cadastro</span>
          </div>
        </Link>
        <Link to="/performance">
          <div className="botaoMenu">
            <span>Performance</span>
          </div>
        </Link>

        <Link to="/catalogo">
          <div className="botaoMenu">
            <span>Catálogo</span>
          </div>
        </Link>
        <Link to="/campanhas">
          <div className="botaoMenu">
            <span>Campanhas</span>
          </div>
        </Link>
        <Link to="/noticia">
          <div className="botaoMenu">
            <span>Institucional</span>
          </div>
        </Link>
        <Link to="/perguntas-frequentes">
          <div className="botaoMenu">
            <span>Perguntas frequentes</span>
          </div>
        </Link>
        <Link to="/fale-conosco">
          <div className="botaoMenu">
            <span>Fale conosco</span>
          </div>
        </Link>
        <Link to="/regulamento">
          <div className="botaoMenu">
            <span>Termo de uso</span>
          </div>
        </Link>
        <Link to="/como-funciona">
          <div className="botaoMenu">
            <span>Como funciona</span>
          </div>
        </Link>
        <Link to="/ranking-libertadores">
          <div
            className="botaoMenu"
            style={{
              borderBottom: "none",
              marginBottom: 50,
            }}
          >
            <span style={{ color: "#c69c56", fontWeight: 900 }}>
              Campanha Libertadores
            </span>
            <div
              style={{
                position: "relative",
                display: "inline-block",
                marginLeft: 10,
              }}
            >
              <img
                src={bola}
                alt="Bola"
                style={{ width: 20, position: "relative", zIndex: 2 }}
              />
              <FireParticles isActive={isBolaActive} />
            </div>
          </div>
        </Link>

        <Link
          to="/"
          onClick={() => {
            storage.del("USUARIO");
          }}
        >
          <button
            className="btn btn-secondary w-100"
            style={{
              padding: 0,
              minHeight: 40,
              fontSize: 13,
              fontWeight: 700,
            }}
          >
            Sair
          </button>
        </Link>
      </div>
    </div>
  );

  // Componente do QR code para desktop
  const DesktopQRCode = () => (
    <div className="desktop-qrcode">
      <div className="desktop-qrcode-content">
        <div className="qrcode-text">
          Escaneie o QRCode abaixo e adicione um atalho nosso em seu celular.
          Assim você pode acompanhar sua evolução de qualquer lugar:
        </div>
        <div className="qrcode-image">
          <img width={200} src={qrCode} alt="QR Code" />
        </div>
      </div>
    </div>
  );

  // Componente do menu hambúrguer para mobile
  const MobileMenu = () => (
    <MenuBurger right customBurgerIcon={<img src={iconMenu} alt="" />}>
      <img width={100} src={logo} alt="" />
      <br />
      <div className="cardPerfilMenu">
        <div className="divAvatarMenu pointer">
          <Avatar nome={eu.nome} font={25} rota={"/meu-cadastro"} />
        </div>

        <div className="divInfoCardMenu">
          <div className="nomeCardPerfilMenu">{eu.nome}</div>
          <div className="filialCardPerfil">
            Filial {eu?.dealer?.nomeFantasia}
          </div>

          <hr />

          <div className="d-flex">
            <div className="">
              <div className="saldoAtualMenu">Saldo atual</div>

              <div className="pontosPerfilMenu">
                {pontosSaldo?.toLocaleString("pt-br", {
                  minimumFractionDigits: 2,
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <Link to="/home">
        <div className="botaoMenu">
          <span>Pagina inicial</span>
        </div>
      </Link>
      <Link to="/meu-cadastro">
        <div className="botaoMenu">
          <span>Meu cadastro</span>
        </div>
      </Link>
      <Link to="/performance">
        <div className="botaoMenu">
          <span>Performance</span>
        </div>
      </Link>

      <Link to="/catalogo">
        <div className="botaoMenu">
          <span>Catálogo</span>
        </div>
      </Link>
      <Link to="/campanhas">
        <div className="botaoMenu">
          <span>Campanhas</span>
        </div>
      </Link>
      <Link to="/noticia">
        <div className="botaoMenu">
          <span>Institucional</span>
        </div>
      </Link>
      <Link to="/perguntas-frequentes">
        <div className="botaoMenu">
          <span>Perguntas frequentes</span>
        </div>
      </Link>
      <Link to="/fale-conosco">
        <div className="botaoMenu">
          <span>Fale conosco</span>
        </div>
      </Link>
      <Link to="/regulamento">
        <div className="botaoMenu">
          <span>Termo de uso</span>
        </div>
      </Link>
      <Link to="/como-funciona">
        <div className="botaoMenu">
          <span>Como funciona</span>
        </div>
      </Link>
      <Link to="/ranking-libertadores">
        <div
          className="botaoMenu"
          style={{
            borderBottom: "none",
            marginBottom: 50,
          }}
        >
          <span style={{ color: "#c69c56", fontWeight: 900 }}>
            Campanha Libertadores
          </span>
          <div
            style={{
              position: "relative",
              display: "inline-block",
              marginLeft: 10,
            }}
          >
            <img
              src={bola}
              alt="Bola"
              style={{ width: 20, position: "relative", zIndex: 2 }}
            />
            <FireParticles isActive={isBolaActive} />
          </div>
        </div>
      </Link>

      <Link
        to="/"
        onClick={() => {
          storage.del("USUARIO");
        }}
      >
        <button
          className="btn btn-secondary w-100"
          style={{
            padding: 0,
            minHeight: 40,
            fontSize: 13,
            fontWeight: 700,
          }}
        >
          Sair
        </button>
      </Link>
    </MenuBurger>
  );

  async function fnUsuario() {
    try {
      setLoad(true);
      const response = await ApiServices.apiGet("eu");
      setEu(response.data);
      // Salva os dados em cache
      storage.set("USER_DATA", response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnPontos() {
    try {
      setLoad(true);
      const response = await ApiServices.apiGet("campanha/meu-resumo");
      setPontos(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnVizualizarNotificacoes(id, categoria) {
    var objEnvio = {
      ids: [id],
    };
    try {
      setLoad(true);
      const response = await ApiServices.apiPut(
        "notificacoes/marcar/lidos",
        objEnvio
      );

      categoria == "faleConosco" && navigate("/fale-conosco-historico");
      categoria == "noticias" && navigate("/noticia");
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnNotificacoesFaleConosco() {
    try {
      setLoad(true);
      const response = await ApiServices.apiGet(
        "notificacoes?tipo=faleConosco"
      );
      setNotificacoesListaFaleConosco(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnNotificacoesNoticias() {
    try {
      setLoad(true);
      const response = await ApiServices.apiGet("notificacoes?tipo=noticia");
      setNotificacoesListaNoticias(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnPerformanceResumo() {
    try {
      setLoad(true);
      const response = await ApiServices.apiGet("performance/meu-resumo");
      setPontosCreditados(response.data.pontosGanhos);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  // async function fnPontosExtract() {
  //   try {
  //     setLoad(true);
  //     const response = await ApiServices.apiPostCatalogo("extract");
  //     setPontosCreditados(response.creditBalance);
  //   } catch (err) {
  //     console.error("err", err);
  //   } finally {
  //     setLoad(false);
  //   }
  // }
  async function fnPontosBalance() {
    try {
      setLoad(true);
      const response = await ApiServices.apiPostCatalogo("balance");
      setPontosSaldo(response.balance);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  useEffect(() => {
    // Cache para evitar chamadas desnecessárias
    const userData = storage.get("USER_DATA");
    const lastCall = storage.get("LAST_API_CALL");
    const now = Date.now();
    
    // Só chama a API se não tiver dados em cache ou se passou mais de 5 minutos
    if (!userData || !lastCall || (now - lastCall) > 300000) {
      fnUsuario();
      storage.set("LAST_API_CALL", now);
    } else {
      setEu(userData);
    }
    
    fnPontos();
    fnNotificacoesFaleConosco();
    fnNotificacoesNoticias();
    // fnPontosExtract();
    fnPerformanceResumo();
    fnPontosBalance();
  }, []);

  function obterLetras(palavras) {
    // Divide a string em palavras com base nos espaços em branco
    const partes = palavras.split(" ");

    if (partes.length >= 1) {
      const primeiraPalavra = partes[0];
      const primeiraLetra = primeiraPalavra[0];

      if (partes.length >= 2) {
        const segundaPalavra = partes[1];
        return primeiraLetra + segundaPalavra[0];
      } else {
        return primeiraPalavra.slice(0, 2);
      }
    }
    return null; // Retorna nulo se a string estiver vazia
  }
  return (
    <>
      {/* Menu lateral fixo para desktop */}
      {!isMobile && <DesktopSidebar />}

      {/* QR Code lateral fixo para desktop */}
      {!isMobile && <DesktopQRCode />}

      {/* Header para mobile e desktop */}
      <div style={{ backgroundColor: "#25293F", height: 60, color: "#DEE3EB" }}>
        <div className="d-flex justify-content-center position-relative">
          <div className="w-100" style={{ maxWidth: 500 }}>
            <div
              className="d-flex justify-content-between w-100 align-items-center px-3"
              style={{ height: 60 }}
            >
              <div>Bem-vindo!</div>
              <div
                className="d-flex align-items-center"
                style={{ paddingRight: 60 }}
              >
                {window.location.pathname === "/home" && (
                  <div
                    className="alertaNoticidacaoIcone me-3"
                    onClick={() => {
                      setAbrirNotificacaoNoticias(true);
                    }}
                  >
                    <div className="alertaNotificacao">
                      {" "}
                      {notificacoesListaNoticias?.length > 9
                        ? 9 + "+"
                        : notificacoesListaNoticias?.length}
                    </div>
                    <img
                      style={{ paddingLeft: 3 }}
                      className="me-4"
                      src={papel}
                      alt=""
                    />
                  </div>
                )}
                {window.location.pathname === "/home" && (
                  <div
                    className="alertaNoticidacaoIcone"
                    onClick={() => {
                      setAbrirNotificacaoFaleConosco(true);
                    }}
                  >
                    <div className="alertaNotificacao">
                      {notificacoesListaFaleConosco?.length > 9
                        ? 9 + "+"
                        : notificacoesListaFaleConosco?.length}
                    </div>
                    <img
                      className=""
                      style={{ marginTop: -3, paddingLeft: 8 }}
                      src={sino}
                      alt=""
                    />
                  </div>
                )}
                <div>{isMobile && <MobileMenu />}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {abrirNotificacaoFaleConosco && (
        <div
          className="bgNotificacoes d-flex justify-content-center "
          onClick={() => {
            setAbrirNotificacaoFaleConosco(false);
          }}
        >
          <div className="listaNotificacao">
            <>
              {notificacoesListaFaleConosco.map((e, i) => (
                <div
                  key={i}
                  className="divNotificacao"
                  onClick={(ele) => {
                    ele.stopPropagation();
                    fnVizualizarNotificacoes(e.notificacaoId, "faleConosco");
                    setAbrirNotificacaoFaleConosco(false);
                  }}
                >
                  <img
                    className="imgNotificacao"
                    src={exclamacao}
                    alt="exclamacao"
                  />
                  <div className="d-flex flex-column ">
                    <div className="textoNotificacao">{e.mensagem}</div>
                  </div>
                </div>
              ))}
              {notificacoesListaFaleConosco.length == 0 && (
                <h3 className="text-center ">Não tem notificações</h3>
              )}
            </>
          </div>
        </div>
      )}
      {abrirNotificacaoNoticias && (
        <div
          className="bgNotificacoes d-flex justify-content-center "
          onClick={() => {
            setAbrirNotificacaoNoticias(false);
          }}
        >
          <div className="listaNotificacao">
            <>
              {notificacoesListaNoticias.map((e, i) => (
                <div
                  key={i}
                  className="divNotificacao"
                  onClick={(ele) => {
                    ele.stopPropagation();
                    fnVizualizarNotificacoes(e.notificacaoId, "noticias");
                    setAbrirNotificacaoNoticias(false);
                  }}
                >
                  <img
                    className="imgNotificacao"
                    src={exclamacao}
                    alt="exclamacao"
                  />
                  <div className="d-flex flex-column ">
                    <div className="textoNotificacao">{e.mensagem}</div>
                  </div>
                </div>
              ))}
              {notificacoesListaNoticias.length == 0 && (
                <h3 className="text-center ">Não tem notificações</h3>
              )}
            </>
          </div>
        </div>
      )}
    </>
  );
}
